import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@blueprintjs/core";
import FindBar from "../FindBar";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor } from "../withEditorProps";
export default connectToEditor(({ findTool = {} }) => {
  return {
    isOpen: findTool.isOpen
  };
})(({
  toolbarItemProps,
  editorName,
  toggleFindTool,
  isOpen,
  additionalEnzymes
}) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: !isOpen ? /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx(Icon, { "data-test": "ve-find-tool-toggle", icon: "search" }),
          /* @__PURE__ */ jsx(Icon, { icon: "caret-right" })
        ] }) : /* @__PURE__ */ jsx(
          FindBar,
          {
            editorName,
            additionalEnzymes
          }
        ),
        renderIconAbove: isOpen,
        onIconClick: toggleFindTool,
        tooltip: isOpen ? /* @__PURE__ */ jsxs("span", { children: [
          "Hide Find Tool ",
          /* @__PURE__ */ jsx("span", { style: { fontSize: 10 }, children: "(Cmd/Ctrl+F)" })
        ] }) : /* @__PURE__ */ jsxs("span", { children: [
          "Show Find Tool ",
          /* @__PURE__ */ jsx("span", { style: { fontSize: 10 }, children: "(Cmd/Ctrl+F)" })
        ] }),
        ...toolbarItemProps
      }
    }
  );
});
